<script setup>
import { onMounted } from "vue";
import store from "./store.js";
import { getAllPrinters, getPrinter } from "./api.js";
import PrinterSelect from "./components/PrinterSelect.vue";
import PrinterThumb from "./components/PrinterThumb.vue";
import { sections } from "./data-map.js";
import Section from "./components/Section.vue";
import ExpandsetSection from "./components/ExpandsetSection.vue";

onMounted(async () => {
    await getAllPrinters();

    const params = new URLSearchParams(window.location.search);
    const preselected = params.getAll("compare[]");

    for (let i = 0; i < Math.min(preselected.length, store.selectedPrinters.length); i++) {
        if (preselected[i]) {
            getPrinter(preselected[i], i);
        }
    }
});
</script>

<template>
    <div class="product-compare-grid">
        <div
            v-for="(printer, index) in store.selectedPrinters"
            :key="index"
            class=""
        >
            <PrinterSelect
                :selected-printer="printer"
                :selected-index="index"
            />
        </div>
    </div>

    <div class="product-compare-grid mt-24">
        <div
            v-for="(printer, index) in store.selectedPrinters"
            :key="index"
            class=""
        >
            <PrinterThumb :selected-printer="printer" />
        </div>
    </div>

    <div class="product-compare-grid mt-24 d-none d-bp:md-grid">
        <div
            v-for="(printer, index) in store.selectedPrinters"
            :key="index"
            class="text-center"
        >
            <a
                v-if="store.selectedPrinters[index]"
                href="#product-questions"
                class="button"
                >Schedule a Demo</a
            >
            <span v-else class="button disabled">Schedule a Demo</span>
        </div>
    </div>

    <div class="d-bp:md-none text-center mt-24">
        <a href="#product-questions" class="button w-full">Schedule a Demo</a>
    </div>

    <div v-for="section in sections" class="mt-24">
        <Section v-if="section.type === 'default'" :section="section" />

        <ExpandsetSection
            v-if="section.type === 'expandset'"
            :section="section"
        />
    </div>

    <div class="product-compare-grid mt-24 px-12">
        <div v-for="(printer, index) in store.selectedPrinters" :key="index">
            <a
                v-if="printer?.specs_download"
                :href="printer.specs_download"
                class="text-link"
            >
                <i
                    class="icon icon-download mr-8 size-sm-snug d-none d-bp:md-inline-block"
                ></i>
                Download Specifications
            </a>
        </div>
    </div>
</template>
